import { createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../../Services/http';
import { ProductPageModel } from '../../../Types/ProductPageModel';

interface SetActiveProductResponse {
  response: ProductPageModel | undefined;
  isPopState: boolean;
}

interface SetActiveProductData {
  id: string;
  isPopState?: boolean;
  currentProductId?: string;
}

export const setActiveProduct = createAsyncThunk(
  'productPage/setActiveProduct',
  async (
    data: SetActiveProductData
  ): Promise<SetActiveProductResponse> => {
    if (data.currentProductId) {
      window.history.replaceState(
        {
          name: 'productSelector',
          productId: data.currentProductId,
        },
        '',
        window.location.href
      );
    }

    const response = await get(`/api/productpage/${data.id}`);
    return {
      response: await response.json(),
      isPopState: data.isPopState ?? false,
    };
  }
);
